module.exports = __webpack_public_path__ + "static/map-049d9973cb0dce08f2ff102aa8f18ce8.png";